import http from "@/api/api";
/*
 * @Author: quwandong
 * @Date: 2022-07-28 14:17:38
 * @LastEditors: quwandong
 * @LastEditTime: 2022-07-29 13:52:41
 * @FilePath: \co-op.nongji360.com\src\utils\mixins.js
 * @Description: mixin.js
 */
// 配置$dictKeyList: { key: '', name: '' } 字典key 集合 取值为 uniqeGlobalDict$$[key]
export const dictMixin = {
  data() {
    if (
      this.$options.$dictKeyList instanceof Array &&
      this.$options.$dictKeyList.length > 0
    ) {
      return { uniqeGlobalDict$$: {} };
    } else {
      return {};
    }
  },
  async created() {
    if (
      this.$options.$dictKeyList instanceof Array &&
      this.$options.$dictKeyList.length > 0
    ) {
      const promise = [];
      this.uniqeGlobalDict$$ = {};
      this.$options.$dictKeyList.forEach(({ key }) => {
        if (key) {
          promise.push(
            http.dict.getCommonDict(key).then((data) => {
              this.$set(this.uniqeGlobalDict$$, key, data.data);
            })
          );
        }
      });
      await Promise.all(promise);
    }
  },
};
